// extracted by mini-css-extract-plugin
export default {"checkBox":"AntCheckbox_checkBox__dbuDH"};